import { useAutoAnimate } from '@formkit/auto-animate/react';

/** auto-animate needs the Web Animations API; without it (tests, very old WebViews) lists simply change. */
const supported = typeof Element !== 'undefined' && typeof Element.prototype.animate === 'function';

/**
 * Items in this list fade in, fade out and slide into their new places
 * (auto-animate) on the panel's timing and curve. It keeps out of the way of
 * reduced motion on its own. For short lists that people add to and take
 * from (a cart, notes); not for lists of more than about 60 rows.
 */
export function useListMotion<T extends HTMLElement>(): ((node: T | null) => void) | undefined {
  const [ref] = useAutoAnimate<T>({ duration: 220, easing: 'cubic-bezier(0.23, 1, 0.32, 1)' });
  // A plain callback type: auto-animate's RefCallback comes from another copy of @types/react.
  return supported ? (ref as (node: T | null) => void) : undefined;
}
